import { EndsIn, OfferHasExpired, StartsOn } from "./texts";
import { StatusONE, StatusTwo, StatusThree, StatusFour, ReceivedSuccess, OKText, CouponSuccessfullyCopied, } from "./coupon";
const mutilLanTextMap = {
    "Starts On": StartsOn,
    "Ends In": EndsIn,
    "We‘re sorry，the offer has expired.": OfferHasExpired,
    "Awesome Coupons are at your fingertips!": StatusONE,
    "These Coupons have run out. <br/>Check back soon! More surprises waiting for you everyday!": StatusTwo,
    "You have already got these Coupons. <br/>Please come back tomorrow.": StatusThree,
    'Check your <a href="%s">Coupons</a> account now.': StatusFour,
    "Received successfully": ReceivedSuccess,
    OK: OKText,
    "Coupon successfully copied": CouponSuccessfullyCopied,
};
export function getLitbLangFn(keyValues, lang = "en") {
    const langSource = mutilLanTextMap[keyValues] || {};
    if (!langSource) {
        return keyValues;
    }
    return langSource[lang] || langSource.en;
}
